module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAnCAMAAADTjiM/AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA/UExURUdwTBZs9Bds9Rdr9hds9RVq9hZq9hdq9Qhi8xdr9Rdr9hRp9hZr9Rdr9Rds9RZr9Q5r+BVo9hZr9Rdr9Rhs9f3vLFYAAAAUdFJOUwBX9PmjKUhgB9fKG3m86GkRN4mF8YlD3wAAAMBJREFUKM91k+kWhSAIhF1KzaWV93/WW9AtFZp/fofDwKhKvdKLkpSMHQUcIsAUON/h1MCwA5Tv8DoTN51FgVutRYZHtcVmX15ZhKnClcUAjf4WvsVgyWI00Evf+/e6LJInkXehw9ZvdrCAqB2/AurjGKepErstxPNH/vxe8odtkdsHTLqwcv3k0gqjntkzWbFNZuWLXE4heHmpqMQszSiX8xmxO58Fh9k5vp6sUH2uar2AHUTp+6xTDtJvc0n8hD/nBxSXJs813QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/arrow-up-blue.png
// module id = 0kYT
// module chunks = 0